
import { Modal, View } from "native-base";
import { Platform, Text, TouchableHighlight } from "react-native";
import { Image } from "expo-image";

export const ActivityTip = ({
  open,
  setOpen,
  onChange
}:{
  open: boolean;
  setOpen: (open: boolean) => void;
  onChange: ()=> void;
}) => {
  return (
    <Modal isOpen={open} size="full" bg="black.700:alpha.70"
      justifyContent="center" alignItems="center"
      style={{
        width: "100%", maxWidth: 460,
        marginLeft: "auto", marginRight: "auto",
      }}>
      <Modal.CloseButton _icon={{ color: "white" }} position="absolute"
        right={2} top={Platform.OS === 'ios' ? 12 : 2} zIndex={2}
        onPress={()=>{setOpen(false)}} />

      <View style={{ width: "100%", alignItems: "center" }}>
        <Image style={{ width: 100, height: 100 }}
          source={ require('../../assets/gift1.png') }
        />
        <Text style={{
          color: "#FFFFFF", fontSize: 24, fontWeight: "bold",
          marginTop: 16, textAlign: "center"
        }}>
          💸 Refer 💸
        </Text>
        <Text style={{
          color: "#FFFFFF", fontSize: 14, fontWeight: "bold",
          marginBottom: 10, marginTop: 4,
          textAlign: "center"
        }}>
          Get more gold coin rewards!
        </Text>
        <View style={{ height: 60, padding: 10, marginTop: 10 }}>
          <TouchableHighlight style={{
            height: 40, borderRadius: 6, paddingLeft: 10, paddingRight: 10,
            width: 200,
            backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
            alignItems: "center", justifyContent: "center"
          }} onPress={onChange}>
            <Text style={{
              fontSize: 18, color: "#FFFFFF", fontWeight: "700"
            }}>
              Go To Refer
            </Text>
          </TouchableHighlight>
        </View>
      </View>
    </Modal>
  )
};